import { render, staticRenderFns } from "./FormTypeDropdown.vue?vue&type=template&id=98f1b634"
import script from "./FormTypeDropdown.vue?vue&type=script&lang=js"
export * from "./FormTypeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports